import { useEffect, useState } from 'react';
import { IconButton, Tooltip, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ReplayIcon from '@mui/icons-material/Replay';
import CallMissedOutgoingOutlinedIcon from '@mui/icons-material/CallMissedOutgoingOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CircularProgress from '@mui/material/CircularProgress';

const progressEnum = {
  waiting: 'WAITING',
  success: 'SUCCESS',
  error: 'ERROR',
};

export const ProgressStep = ({ status, disableOptions = false, onRetry = () => { }, onBypass = () => { }, isLoading = false, stepName, ...props }) => {
  const [progressStatus, setProgressStatus] = useState(progressEnum.waiting);
  const [loadingReq, setLoadingReq] = useState(false);

  useEffect(() => {
    if (status === undefined) return;
    setProgressStatus(status);
  }, [status]);

  useEffect(() => {
    if (isLoading === undefined) return;
    setLoadingReq(isLoading);
  }, [isLoading]);

  return (
    <div {...props} className="w-full flex flex-row justify-between items-center flex-nowrap my-8">
      <Typography
        sx={{
          color: (_theme) => {
            return progressStatus === progressEnum.waiting
              ? '#666666'
              : _theme.palette.text.primary;
          }
        }}
        className="text-slate-300 text-xl"
        gutterBottom
      >
        {stepName}
      </Typography>
      <div className="flex flex-row justify-end items-center" style={{ width: '14rem' }}>
        {!disableOptions && (
          <>
            {progressStatus === progressEnum.error && (
              <div className="mx-4">
                <Tooltip title="Reintentar Step">
                  <IconButton aria-label="retry" onClick={() => onRetry()}>
                    <ReplayIcon />
                  </IconButton>
                </Tooltip>
              </div>
            )}
            <div className="mx-4">
              <Tooltip title="Ignorar Step">
                <IconButton aria-label="bypass" onClick={() => onBypass()}>
                  <CallMissedOutgoingOutlinedIcon />
                </IconButton>
              </Tooltip>
            </div>
          </>
        )}
        <div style={{ width: '4rem' }} className="mx-4 flex justify-center items-center">
          {loadingReq && <CircularProgress color="primary" size="2em" />}
          {progressStatus === progressEnum.waiting && !loadingReq && (
            <MoreHorizIcon sx={{ color: '#666666' }} fontSize="large" />
          )}
          {progressStatus === progressEnum.success && !loadingReq && (
            <CheckCircleOutlineIcon color="success" fontSize="large" />
          )}
          {progressStatus === progressEnum.error && !loadingReq && (
            <ErrorOutlineIcon color="error" fontSize="large" />
          )}
        </div>
      </div>
    </div>
  );
};
